import { VENUE_PHOTO_MIN_HEIGHT_PX, VENUE_PHOTO_MIN_WIDTH_PX } from '@bonsai/shared';
import { AlertCircle } from 'lucide-react';

import { MIN_SIZE_MESSAGE } from './photo-files';

import '../venue-booking-content.css';

export interface PhotoCropNotesProps {
  /** Id for the wrapper, so the crop box can point at these notes. */
  id: string;
  /** Even the biggest crop is under the booking site's minimum, so it cannot be saved. */
  belowMinimum: boolean;
  /** The photo is big enough to use but has no room to zoom. */
  tooSmallToZoom: boolean;
  portrait: boolean;
}

/** Notes about the chosen photo: too small to use, too small to zoom, or mostly cut off. */
export function PhotoCropNotes({
  id,
  belowMinimum,
  tooSmallToZoom,
  portrait,
}: PhotoCropNotesProps) {
  return (
    <div id={id} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {belowMinimum && (
        <div
          className="vbc-error"
          style={{
            borderRadius: 10,
            padding: '8px 10px',
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.4,
          }}
        >
          {MIN_SIZE_MESSAGE}
        </div>
      )}
      {tooSmallToZoom && !belowMinimum && (
        <div style={{ fontSize: 11.5, lineHeight: 1.45, color: 'var(--nb-muted)' }}>
          This photo is too small to zoom in — the booking site needs at least{' '}
          {VENUE_PHOTO_MIN_WIDTH_PX} by {VENUE_PHOTO_MIN_HEIGHT_PX} pixels.
        </div>
      )}
      {portrait && (
        <div
          className="vbc-warn-line"
          style={{
            display: 'flex',
            gap: 7,
            alignItems: 'flex-start',
            fontSize: 11.5,
            lineHeight: 1.45,
          }}
        >
          <span style={{ display: 'flex', marginTop: 1 }}>
            <AlertCircle size={13} aria-hidden="true" />
          </span>
          <span>
            Most of this photo will be cut off — it&apos;s much taller than the booking site&apos;s
            wide banner.
          </span>
        </div>
      )}
    </div>
  );
}
